<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center" v-if="showList">
      <b-col  lg="8">
        <b-card>
          <div slot="header">Platform Iklan Digital  
            <div class="card-header-actions">
              <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
              <button class="btn btn-primary mr-1" @click="exportxls()">
                  <i class="fa fa-file-excel-o"></i>
                  Export
              </button>
              <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </div>
          </div>
        <b-row >
          <b-col lg="9">
              <b-input-group >
                  <b-input-group-prepend><span class="pt-2 mr-2">Filter of </span></b-input-group-prepend>
                  <b-form-input v-model="filter.platform" placeholder="Platform Name"></b-form-input>
                  <b-input-group-append><span class="p-2">Active</span></b-input-group-append>
                  <b-form-select v-model="filter.isactive" :plain="true" :options="activeStatus" ></b-form-select>
              </b-input-group>
          </b-col>
          <b-col md="3">
                <b-row>
                  <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                  <b-button class="btn btn-secondary mr-1" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
                </b-row>
          </b-col>
        </b-row>

          <b-table
            class="mb-0"
            ref="table"
            outlined  responsive hover small
            style="font-size:smaller;" 
            :items="data"
            :fields="tblFields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"

            @row-clicked="rowClicked"
          >
            <template v-slot:cell(nomor)="data">
              {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
            </template>

            <template v-slot:cell(action)="data">
              <div class="text-center">
              <a href="javascript:void(0)" @click.stop="edit(data.item)">
                <i class="fa fa-pencil"></i>
              </a>
              |
              <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
                <i class="fa fa-trash"></i>
              </a>
              </div>
            </template>
          </b-table>
          <b-row class="mt-2">
            <b-col cols="6">
              <div>
                Showing {{(tblData.page - 1) * tblData.limit + 1}}
                to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
                of {{tblData.total}} entries
              </div>
            </b-col>
            <b-col cols="6">            
              <b-pagination
                align="right"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
            </b-col>
          </b-row>

          <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
            <p class="mb-1">1 record is about to be permanently deleted</p>
            <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
          </b-modal>
        </b-card>
        </b-col>
    </b-row>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card >
          <div slot="header">Platform Iklan Digital - Add/Edit Form </div>
              <b-form-group  label-cols=3  label="Platform Name" >
                  <b-form-input v-model="frmdata.platform" :state="!$v.frmdata.platform.$error"></b-form-input>
              </b-form-group>
              <b-form-group  label-cols=3  label="Sales Account" >
                  <b-input-group>
                      <b-form-input readonly v-model="frmdata.kodesales" @keyup.13.native="lkuItemShow=true" ></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="lkuItemShow=true">
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
                  </b-input-group>
              </b-form-group>
              <b-form-group  label-cols=3  label="Active" >
                  <b-form-select v-model="frmdata.isactive" :plain="true" :options="activeStatus" ></b-form-select>
              </b-form-group>
            <div slot="footer" style="text-align:center;">
              <button class="btn btn-primary mr-1" @click="save()">
                <i class="fa fa-save"></i> Save
              </button>
             <b-button variant="secondary" class="mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
            </div>
        </b-card>
      </b-col>
    </b-row>
        <b-modal v-model="lkuItemShow" size="lg" :hide-footer="true" title="List of Sales Items"  :centered="true">
            <lku-item @click="onSelectLkuItem" ></lku-item>
        </b-modal>        

  </div>
</template>


<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import crudexport from "../../apis/crudexport";
import lkuItem from "../lookup/lkuLookupSales";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
    components: {lkuItem},
  mixins: [validationMixin],
  validations: {
    frmdata: {
        platform: { required },
        isactive: { required },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      showList:true,
      showForm:false,
      lkuItemShow:false,
      frmdata:{platform: '',kodesales:'',isactive:1 },
      tblData: {
        tablename:'koran-platform-digital',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'platform',
        sortDesc: false,
      },
      filter:{ platform:'', isactive:''},
      activeStatus : [{ value: '', text: '-- ALL --' },, { value: '0', text: 'Non Active' },{ value: '1', text: 'Active/In Use' }],

    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "nomor",
            label: "No.",
            thStyle: "width:60px"
          },
          {
            key: "platform",
            label: "Platform Name",
            sortable: true
          },
          {
            key: "kodesales",
            label: "Sales Account",
            sortable: true
          },
          {
            key: "isactive",
            label: "Active",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:80px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },
  methods: {
    onSelectLkuItem(_selected) {
        this.frmdata.kodesales = _selected.saleCrCode;
        this.lkuItemShow=false;
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
            let str ='isdeleted=0';
            if (this.filter.platform){
              str += str ? '&' : '';
              str = str + 'platform=%' + encodeURIComponent(this.filter.platform)+'%';
            }
            if (this.filter.isactive){
              str += str ? '&' : '';
              str = str + 'isactive=' + encodeURIComponent(this.filter.isactive)+'';
            }
            this.tblData.customQuery=str;      

            await crudexport.crewdepartemen(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },   
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      let str ='isdeleted=0';
      if (this.filter.platform){
        str += str ? '&' : '';
        str = str + 'platform=%' + encodeURIComponent(this.filter.platform)+'%';
      }
      if (this.filter.isactive){
        str += str ? '&' : '';
        str = str + 'isactive=' + encodeURIComponent(this.filter.isactive)+'';
      }
      this.tblData.customQuery=str;      
      const list = await crud.list(this.tblData);      
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    add: function(data) {
        this.frmdata.platformid = '';
        this.frmdata.platform = '';
        this.frmdata.isactive = 1;
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        this.frmdata.platformid = '';
        this.frmdata.platform = '';
        this.frmdata.isactive = 0;
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.idlama = data.platformid;
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              if (this.frmdata.idlama) {
                await crud.update(
                     {tablename:'koran-platform-digital', 
                     key:this.frmdata.idlama, 
                     data:{platform:this.frmdata.platform.toUpperCase(),
                     isactive: this.frmdata.isactive}
                      });
              } else {
                await crud.insert(
                  { tablename:'koran-platform-digital',                      
                     data:{platform:this.frmdata.platform.toUpperCase(),
                     isactive: this.frmdata.isactive}
                  });
              }
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'koran-platform-digital', key:this.model.platformid});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    clearFilter(ctx) {
        this.filter.platform= '';
        this.filter.isactive= '';
        this.refresh();
    },    
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push({name: "iklankoran.home"});
    },    
  }
};
</script>
